import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../utils/imageUtils";

const ProjectsPreview = ({ t, lang, data, loading }) => {
    return (
        <>
            {loading ? (
                <section className="py-5 bg-card">
                    <div className="container text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </section>
            ) : (
                data.projects.length > 0 && (
                    <section className="py-5 bg-card">
                        <div className="container">
                            {/* Header */}
                            <div
                                className="d-flex justify-content-between align-items-end mb-5"
                                data-aos="zoom-in"
                            >
                                <div>
                                    <h2 className="fw-bold">
                                        {t("home_projects_2", "Featured Projects")}
                                    </h2>
                                    <p className="text-muted mb-0">
                                        {t("home_projects_desc")}
                                    </p>
                                </div>

                                <Link
                                    to="/projects"
                                    className="btn btn-outline-custom d-none d-md-inline-flex"
                                >
                                    {t("home_projects_btn", "All Projects")}
                                </Link>
                            </div>

                            {/* Projects List */}
                            <div className="row gy-4 justify-content-center">
                                {data.projects.map((p, index) => (
                                    <div className="col-lg-4 col-md-6" key={index} data-aos="fade-up">
                                        <div className="card-custom h-100 p-0 overflow-hidden shadowP">
                                            <div className="position-relative overflow-hidden">
                                                <Link to={`/project/${p.slug_en}`}>
                                                    <img
                                                        src={getImageUrl(p.image, 'imgPro')}
                                                        className="w-100 object-fit-cover"
                                                        style={{ height: "300px" }}
                                                        alt={p.title_en}
                                                    />
                                                </Link>

                                                <div className="position-absolute top-0 start-0 m-3 badge bg-primary text-dark">
                                                    {lang === "en" ? p.sector_en : p.sector_ar}
                                                </div>
                                            </div>

                                            <div className="p-4">
                                                <h4 className="fw-bold mb-2">
                                                    {lang === "en" ? p.title_en : p.title_ar}
                                                </h4>

                                                <p className="text-muted mb-4">
                                                    {lang === "en" ? p.overview_en : p.overview_ar}
                                                </p>

                                                <Link
                                                    to={`/project/${p.slug_en}`}
                                                    className="btn btn-outline-custom w-100"
                                                >
                                                    {t("common_view_case_study", "View Case Study")}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Mobile Button */}
                            <div className="text-center mt-4 d-md-none">
                                <Link
                                    to="/projects"
                                    className="btn btn-outline-custom"
                                >
                                    {t("home_projects_btn")}
                                </Link>
                            </div>
                        </div>
                    </section>
                )
            )}
        </>
    );
};

export default ProjectsPreview;